<template>
    <div  :class="phoneClass || 'help'">
        <content-header></content-header>
        <div class="help-list" >
            <div v-for="(item, index) in file"
                 :key="index"
                 @click="downloadFile(item, index+1)">
                <template v-if="item.type === 'pdf'">
                    <img style="width: 28px;height: 32px" src="../../assets/img/btn/pdf.png" alt="">
                </template>
                <template v-else-if="item.type === 'mp4'">
                    <img style="width: 28px;height: 32px" src="../../assets/img/btn/mp4.jpg" alt="">
                </template>
                <span>{{item.name}}</span>
                <!--<img style="width: 14px;height: 14px" src="../../assets/img/btn/download.png" alt="">-->
            </div>
        </div>
    </div>
</template>

<script>
import Core from 'core/core'
import axios from 'axios';
import contentHeader from '../../components/content-header'
import {refresh} from "core/winSize"
export default {
    components: {
        contentHeader
    },
    data() {
        return {
            phoneClass: '',
            useBrowserPdfViewer: true,
            file: [],
            defaultFile: [
                {
                    name: 'SKF TLDD系列 Quick Start Guide',
                    type: 'pdf',
                    src: '/pdf/help/1.pdf',
                },
                {
                    name: 'SKF TLDD系列 使用说明书 User Manual',
                    type: 'pdf',
                    src: '/pdf/help/2.pdf',
                },
                {
                    name: 'SKF TLDD系列 管理监控平台使用说明书 User Manual',
                    type: 'pdf',
                    src: '/pdf/help/3.pdf',
                },
                {
                    name: '产品视频介绍 - 1. 数字化单点润滑器 - 硬件介绍.mp4',
                    type: 'mp4',
                    src: '/mp4/1.mp4',
                },
                {
                    name: '产品视频介绍 - 2. 数字化单点润滑器 - 软件平台的注册.mp4',
                    type: 'mp4',
                    src: '/mp4/2.mp4',
                },
                {
                    name: '产品视频介绍 - 3a. 数字化单点润滑器 - 润滑器添加方式1.mp4',
                    type: 'mp4',
                    src: '/mp4/3.mp4',
                },
                {
                    name: '产品视频介绍 - 3b. 数字化单点润滑器 - 润滑器添加方式2.mp4',
                    type: 'mp4',
                    src: '/mp4/4.mp4',
                },
                {
                    name: '产品视频介绍 - 4. 数字化单点润滑器 - 润滑器设置更改和解绑.mp4',
                    type: 'mp4',
                    src: '/mp4/5.mp4',
                },
            ],
            jaFile: [
                {
                    name: 'SKF SYSTEM 24 TLDDシリーズ_クイックマニュアル_MP 5504 JA_February 2026.pdf',
                    type: 'pdf',
                    src: '/pdf/japan-help/SKF SYSTEM 24 TLDDシリーズ_クイックマニュアル_MP 5504 JA_February 2026.pdf',
                },
                {
                    name: 'SKF SYSTEM24 TLDDシリーズ_取扱説明_MP5502 JA_May 2026.pdf',
                    type: 'pdf',
                    src: '/pdf/japan-help/SKF SYSTEM24 TLDDシリーズ_取扱説明_MP5502 JA_May 2026.pdf',
                },
                {
                    name: 'SKF SYSTEM24 TLDDシリーズ_ソフトウェア ユーザーマニュアル_MP5505 JA_February 2026.pdf',
                    type: 'pdf',
                    src: '/pdf/japan-help/SKF SYSTEM24 TLDDシリーズ_ソフトウェア ユーザーマニュアル_MP5505 JA_February 2026.pdf',
                },
                {
                    name: 'TLDDシリーズ_ワイヤレス式電動SYSTEM 24_MP-P2_18682-4_JA_May 2026.pdf',
                    type: 'pdf',
                    src: '/pdf/japan-help/TLDDシリーズ_ワイヤレス式電動SYSTEM 24_MP-P2_18682-4_JA_May 2026.pdf',
                },
            ]
        }
    },
    mounted() {
        this.file = this.getHelpFiles()
        this.initRefresh()
    },
    methods: {
        getHelpFiles() {
            const lang = this.$i18n && this.$i18n.locale ? this.$i18n.locale : ''
            return (lang === 'ja' ? this.jaFile : this.defaultFile).slice()
        },
        getPdfUrl(src) {
            if (this.useBrowserPdfViewer) {
                return encodeURI(src)
            }
            const routeUrl = this.$router.resolve({
                path: `/show-pdf?src=${encodeURIComponent(src)}`,
            })
            return routeUrl.href
        },
        initRefresh() {
            refresh(this,'phoneClass-home');
            window.onresize = function(){
                setTimeout(function(){
                    refresh(this,'phoneClass-home');
                },10)
            };
        },
        downloadFile(item, num) {
            let routeUrl
            if (item.type === 'pdf') {
                routeUrl = {
                    href: this.getPdfUrl(item.src),
                }
            } else {
                routeUrl = this.$router.resolve({
                    path: `/show-mp4?src=${item.src}`,
                });
            }
            window.open(routeUrl.href, '_blank');
            // window.open(Core.Const.NET.IMPORT_FILE + 'pdf/' + num + '.pdf')
            // axios({
            // 	method: "GET",
            // 	url: Core.Const.NET.IMPORT_FILE + 'pdf/1.pdf',
            // 	responseType: 'blob',
            // 	// data: 'data' //需要传的字段
            // })
            // .then(res => {
            // 	console.log (res)
            //
            // 	let blob = new Blob([res.data], {
            // 		type: `application/pdf` //word文档为msword,pdf文档为pdf
            // 	});
            // 	let objectUrl = URL.createObjectURL(blob);
            // 	let link = document.createElement("a");
            // 	let fname = `SKF TLDD系列 Quick Start Guide`; //下载文件的名字
            // 	link.href = objectUrl;
            // 	link.setAttribute("download", fname);
            // 	document.body.appendChild(link);
            // 	link.click();
            // }).catch(e => {
            // 	console.log (e)
            // })
            // window.open();

        }
    }
}
</script>

<style scoped lang="scss">
.help {
    .help-list {
        width: 80%;
        margin: 30px auto 0;
        padding: 50px;
        background: white;
        display: flex;
        flex-wrap: wrap;
        >div {
            color: #1E283C;
            display: flex;
            width: 30%;
            align-items: center;
            min-width: 290px;
            height: 56px;
            background: rgba(244,244,245,1);
            border-radius: 4px;
            cursor: pointer;
            margin-right: 30px;
            padding: 0 10px;
            margin-bottom: 12px;
            img {

            }
            span {
                margin-left: 10px;
            }
        }
    }
}

.phoneClass-home {
    .help-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        background: white;
        margin: 30px 10px;
        padding: 20px 0;
        >div {
            display: flex;
            align-items: center;
            width: 300px;
            height: 56px;
            background: rgba(244,244,245,1);
            border-radius: 4px;
            padding: 0 10px;
            margin-top: 10px;
            span {
                margin-left: 10px;
            }
        }
    }
}
</style>
